
export const ProductData=[
    {
    id:1,
    img:require('../Images/SheetImg/SheetMainimg.jpg'),
    heading:"Sheet & Plate",
    link:'/SheetMain',
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:2,
    img:require('../Images/newproduct/img1.jpg'),
    heading:"COILS & STIRPS",
    link:'/Coils',
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require('../Images/BarImg/BarMainImg.jpg'),
    heading:"ROUND BAR",
    link:'/ROUND_BAR',
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:4,
    img:require('../Images/WireImg/WireMainImg.jpg'),
    heading:"WIRE",
    link:'/WIRE',
    text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
    
  },
  {
    id:5,
    img:require('../Images/newproduct/img5.webp'),
    heading:"Pipes & Tubes",
    link:'/Pipes_tubes',
    text:'Obtain the best pricing and secure the most reliable deliveries for High Nickel Alloy',
    
  },
  {
    id:6,
    img:require('../Images/newproduct/img3.jpg'),
    heading:"Welding Consumables",
    link:'/Welding_Consumables',
    text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
    
  },
  {
    id:7,
    img:require('../Images/newproduct/img6.jpg'),
    heading:"Pipe Fittings",
    link:'/Pipe_Fittings',
    text:'Obtain the best pricing and secure the most reliable deliveries for High Nickel Alloy',

    child_data:[
      {
        id:1,
        img:require('../Images/Pipefitings/Img1.webp'),
        heading:"Buttweld Pipe Fittings",
        link:'/Buttweld_Pipe_Fittings',                           
        text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
      },
      {
        id:2,
        img:require('../Images/Pipefitings/Bgimg2.jpg'),
        heading:"Threaded Pipe Fittings",
        link:'/Threaded_Pipe_Fittings',
        text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
      },
      {
        id:3,
        img:require('../Images/Pipefitings/Bgimg1.jpg'),
        heading:"Socket Weld  Pipe Fittings",
        link:"/MGalvanized_Pipe_Fittings",
        text:'All our products go through various quality checks from procurement to final delivery.',
        
      },
      {
        id:3,
        img:require('../Images/Pipefitings/Bgimg3.jpg'),
        heading:"Olets Pipe Fittings",
        link:"/Olets_Pipe_Fittings",
        text:'All our products go through various quality checks from procurement to final delivery.',
        
      },{
        id:3,
        img:require('../Images/ferul_img/img2.jpg'),
        heading:"Ferrule Pipe Fittings",
        link:"/Ferrule_Pipe_Fittings",
        text:'All our products go through various quality checks from procurement to final delivery.',
        
      }
    ]
    
  },
  {
    id:8,
    img:require('../Images/newproduct/img7.jpg'),
    heading:"Flanges",
    link:'/Flanges',
    text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
   

    child_data:[
      {
        id: 1,
        img: require("../Images/FlangeImg/img1.jpg"),
        heading: "ANSI Norm Flanges",
        link: "/ANSI_Norm_Flanges",
        text: "We stock huge inventories of all our products in all standard sizes to ensure timely delivery.",
      },
      {
        id: 2,
        img: require("../Images/FlangeImg/img2.jpg"),
        heading: "UNI Norm Flanges",
        link: "/UNI_Norm_Flanges",
        text: "We stock huge inventories of all our products in all standard sizes to ensure timely delivery.",
      },
      {
        id: 3,
        img: require("../Images/FlangeImg/img3.jpg"),
        heading: "EN Norm Flanges",
        link: "/EN_Norm_Flanges",
        text: "All our products go through various quality checks from procurement to final delivery.",
      },
      {
        id: 4,
        img: require("../Images/FlangeImg/img4.jpg"),
        heading: "BS Norm Flanges",
        link: "/BS_Norm_Flanges",
        text: "We stock huge inventories of all our products in all standard sizes to ensure timely delivery.",
      },
      {
        id: 5,
        img: require("../Images/FlangeImg/img5.jpg"),
        heading: "JIS Norm Flanges",
        link: "/JIS_Norm_Flangess",
        text: "We stock huge inventories of all our products in all standard sizes to ensure timely delivery.",
      },
      {
        id: 6,
        img: require("../Images/FlangeImg/img6.jpg"),
        heading: "DIN Norm Flanges",
        link: "/DIN_Norm_Flanges",
        text: "All our products go through various quality checks from procurement to final delivery.",
      },
    ]
    
  },
  {
    id:9,
    img:require("../Images/fasteners/fastner3.png"),
    heading:"Nickel Fasteners",
    link:'/products/nickel_fasteners',
    text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
    
  },
]

export const SheetData=[
  {
  id:1,
  img:require('../Images/SheetImg/Sheet1.jpg'),
  heading:"SS Sheet/Plate",
  link:'/SSsheet',                           
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require('../Images/SheetImg/Sheet2.jpg'),
  heading:"Inconel Sheet/Plate",
  link:'/InconelSheet',
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require('../Images/SheetImg/Sheet3.jpg'),
  heading:"Monel  Sheet/Plate",
  link:'/MonelSheet',
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:4,
  img:require('../Images/SheetImg/Sheet4.jpg'),
  heading:"NICKEL Sheet/Plate",
  link:'/NickelSheet',
  text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
  
},
{
  id:6,
  img:require('../Images/SheetImg/Sheet5.jpg'),
  heading:"TITANIUM Sheet/Plate",
  link:'/titaniumSheet',
  text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
  
},

{
  id:8,
  img:require('../Images/SheetImg/Sheet6.jpg'),
  heading:"A-286 Sheet/Platee",
  link:'/A286Sheet',
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:9,
  img:require('../Images/SheetImg/Sheet7.jpg'),
  heading:"SMO 254 Sheet/Plate",
  link:'/SMO254Sheet',
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:10,
  img:require('../Images/SheetImg/Sheet8.jpg'),
  heading:"Hastelloy Sheet/Plate",
  link:'/HastelloySheet',
  text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
  
},
{
  id:5,
  img:require('../Images/SheetImg/Sheet9.jpg'),
  heading:"Alloy 20 Sheet/Plate",
  link:'/Alloy20Sheet',
  text:'Obtain the best pricing and secure the most reliable deliveries for High Nickel Alloy',
  
},
{
  id:12,
  img:require('../Images/SheetImg/Sheet10.jpg'),
  heading:"Duplex & Superduplex Sheet/Plate",
  link:'/DuplexSuperduplexSheet',
  text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
 
},
]


export const RoundBarData=[
    {
    id:1,
    img:require('../Images/BarImg/Bar9.jpg'),
    heading:"SS Round Bar",
    link:'/SSRoundBar',                           
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:2,
    img:require('../Images/BarImg/Bar8.jpg'),
    heading:"Inconel Round Bar",
    link:'/InconelRoundBar',
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require('../Images/BarImg/Bar3.jpg'),
    heading:"Monel Round Bar",
    link:'/MonelRoundBar',
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:4,
    img:require('../Images/BarImg/Bar4.jpg'),
    heading:"NICKEL Round Bar",
    link:'/NickelRoundBar',
    text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
    
  },
  {
    id:6,
    img:require('../Images/BarImg/Bar5.jpg'),
    heading:"TITANIUM Round Bar",
    link:'/titaniumCRoundBar',
    text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
    
  },

  {
    id:8,
    img:require('../Images/BarImg/Bar6.jpg'),
    heading:"A-286 Round Bar",
    link:'/A286RoundBar',
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:9,
    img:require('../Images/BarImg/BarMainImg.jpg'),
    heading:"SMO 254 Round Bar",
    link:'/SMO254RoundBar',
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:10,
    img:require('../Images/BarImg/Bar8.jpg'),
    heading:"Hastelloy Round Bar",
    link:'/HastelloyRoundBar',
    text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
    
  },
  {
    id:5,
    img:require('../Images/BarImg/Bar9.jpg'),
    heading:"Alloy 20 Round Bar",
    link:'/Alloy20RoundBar',
    text:'Obtain the best pricing and secure the most reliable deliveries for High Nickel Alloy',
    
  },
  {
    id:12,
    img:require('../Images/BarImg/Bar10.jpg'),
    heading:"Duplex Superduplex Round Bar",
    link:'/DuplexSuperduplexRoundBar',
    text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
    
  },
]

export const WireData=[
  {
  id:1,
  img:require('../Images/WireImg/Wire1.jpg'),
  heading:"SS Wire",
  link:'/SSWire',                           
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require('../Images/WireImg/Wire3.jpg'),
  heading:"Inconel Wire",
  link:'/InconelWire',
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require('../Images/WireImg/Wire4.jpg'),
  heading:"Monel Wire",
  link:'/MonelWire',
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:4,
  img:require('../Images/WireImg/Wire5.jpg'),
  heading:"NICKEL Wire",
  link:'/NickelWire',
  text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
  
},
{
  id:6,
  img:require('../Images/WireImg/Wire2.jpg'),
  heading:"TITANIUM Wire",
  link:'/titaniumCWire',
  text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
  
},

{
  id:9,
  img:require('../Images/WireImg/Wire7.jpg'),
  heading:"SMO 254 Wire",
  link:'/SMO254Wire',
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:10,
  img:require('../Images/WireImg/Wire8.jpg'),
  heading:"Hastelloy Wire",
  link:'/HastelloyWire',
  text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
  
},
{
  id:5,
  img:require('../Images/WireImg/Wire9.jpg'),
  heading:"Alloy 20 Wire",
  link:'/Alloy20Wire',
  text:'Obtain the best pricing and secure the most reliable deliveries for High Nickel Alloy',
  
},
{
  id:12,
  img:require('../Images/WireImg/Wire10.jpg'),
  heading:"Duplex Superduplex Wire",
  link:'/DuplexSuperduplexWire',
  text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
  
},
]

export const CoilsData=[
  
  {
  id:1,
  img:require("../Images/CoilsImg/Coils1.jpg"),
  heading:"SS Coils & Stirps",
  link:'/SSCoils',                           
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require("../Images/CoilsImg/img1.jpg"),
  heading:"Inconel Coils & Stirps",
  link:'/InconelCoils',
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require("../Images/CoilsImg/Coils3.jpg"),
  heading:"Monel  Coils & Stirps",
  link:'/MonelCoils',
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:4,
  img:require("../Images/CoilsImg/img2.jpg"),
  heading:"NICKEL Coils & Stirps",
  link:'/NickelCoils',
  text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
  
},
{
  id:6,
  img:require("../Images/CoilsImg/Coils5.jpg"),
  heading:"TITANIUM Coils & Stirps",
  link:'/titaniumCoils',
  text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
  
},

{
  id:8,
  img:require("../Images/CoilsImg/img3.jpg"),
  heading:"A-286 Coils & Stirps",
  link:'/A286Coils',
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:9,
  img:require("../Images/CoilsImg/Coils7.jpg"),
  heading:"SMO 254 Coils & Stirps",
  link:'/SMO254Coils',
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:10,
  img:require("../Images/CoilsImg/img4.jpg"),
  heading:"Hastelloy Coils & Stirps",
  link:'/HastelloyCoils',
  text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
  
},
{
  id:11,
  img:require("../Images/CoilsImg/Coils9.jpg"),
  heading:"Alloy 20 Coils & Stirps",
  link:'/Alloy20Coils',
  text:'Obtain the best pricing and secure the most reliable deliveries for High Nickel Alloy',
  
},
{
  id:12,
  img:require("../Images/CoilsImg/img5.jpeg"),
  heading:"Duplex Superduplex Coils & Stirps",
  link:'/DuplexSuperduplexCoils',
  text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
  
},
]


export const PipesData=[
  {
  id:1,
  img:require("../Images/GalleryImg/SeamlessPipe/Timg1.jpg"),
  heading:"SS Pipes/tubes",
  link:'/SSPipes',                           
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:2,
  img:require("../Images/GalleryImg/SeamlessPipe/Timg2.jpg"),
  heading:"Inconel Pipes/tubes",
  link:'/InconelPipes',
  text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
},
{
  id:3,
  img:require("../Images/GalleryImg/SeamlessPipe/Timg8.jpg"),
  heading:"Monel  Pipes/tubes",
  link:'/MonelPipes',
  text:'All our products go through various quality checks from procurement to final delivery.',
  
},
{
  id:4,
  img:require("../Images/GalleryImg/SeamlessPipe/Timg4.jpg"),
  heading:"NICKEL Pipes/tubes",
  link:'/NickelPipes',
  text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
  
},
{
  id:6,
  img:require("../Images/GalleryImg/SeamlessPipe/Timg5.jpg"),
  heading:"TITANIUM Pipes/tubes",
  link:'/titaniumPipes',
  text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
  
},


{
  id:10,
  img:require("../Images/GalleryImg/SeamlessPipe/Timg6.jpg"),
  heading:"Hastelloy Pipes/tubes",
  link:'/HastelloyPipes',
  text:'We aim to ensure timely delivery of all the orders within given time and is often an area of focus for process improvement initiatives.',
  
},

{
  id:12,
  img:require("../Images/GalleryImg/SeamlessPipe/Timg9.jpg"),
  heading:"Duplex Superduplex Pipes/tubes",
  link:'/DuplexSuperduplexPipes',
  text:'All Inconel (Alloy 600, 601, 625, 718) & Hastelloy (Alloy c22, C276) Sheet, Plates are available in cut to size',
  
},
]
export const SheetoptionData=[
  {
  id:1,
  
  grade:"SS Sheet/Plate",
  link:'/SSsheet',  
  name:"SS Sheet/Plate"                         
},
{
  id:2,
  grade:"Inconel Sheet/Plate",
  link:'/InconelSheet',
  name:"Inconel Sheet/Plate"    
},
{
  id:3,
  grade:"Monel  Sheet/Plate",
  link:'/MonelSheet',
  name:"Monel  Sheet/Plate"    


  
},
{
  id:4,
  grade:"NICKEL Sheet/Plate",
  link:'/NickelSheet',
  name:"NICKEL Sheet/Plate"
},
{
  id:6,
  grade:"TITANIUM Sheet/Plate",
  link:'/titaniumSheet',
 
  
},

{
  id:8,
  grade:"A-286 Sheet/Platee",
  link:'/A286Sheet',
},
{
  id:9,
  grade:"SMO 254 Sheet/Plate",
  link:'/SMO254Sheet',
},
{
  id:10,
  grade:"Hastelloy Sheet/Plate",
  link:'/HastelloySheet',
},
{
  id:5,
  grade:"Alloy 20 Sheet/Plate",
  link:'/Alloy20Sheet',

},
{
  id:12,
 
  grade:"Duplex Superduplex Sheet/Plate",
  link:'/DuplexSuperduplexSheet',
},
]

export const CoilsoptionData=[

  {
  id:1,
  
  grade:"SS Coils & Stirps",
  link:'/SSCoils',                           

},
{
  id:2,
  grade:"Inconel Coils & Stirps",
  link:'/InconelCoils',

},
{
  id:3,
  grade:"Monel  Coils & Stirps",
  link:'/MonelCoils',


  
},
{
  id:4,
  grade:"NICKEL Coils & Stirps",
  link:'/NickelCoils',

},
{
  id:6,
  grade:"TITANIUM Coils & Stirps",
  link:'/titaniumCoils',

 
  
},

{
  id:8,
  grade:"A-286 Coils & Stirps",
  link:'/A286Coils',

},
{
  id:9,
  grade:"SMO 254 Coils & Stirps",
  link:'/SMO254Coils',
},
{
  id:10,
  grade:"Hastelloy Coils & Stirps",
  link:'/HastelloyCoils',
},
{
  id:5,
  grade:"Alloy 20 Coils & Stirps",
  link:'/Alloy20Coils',

},
{
  id:12,
 
  grade:"Duplex Superduplex Coils & Stirps",
  link:'/DuplexSuperduplexCoils',
},
]

export const  SSsheetGradeData=[

{
  id:1,
  grade:'SS 201 Sheets & Plates',
  link:'/SS201Grade'
 
},
{
  id:2,
  grade:'SS 202 Sheets & Plates',
  link:'/SS202Grade'
},
{
  id:3,
  grade:'SS 301 Sheets & Plates',
  link:'/SS301Grade'
},

{
  id:7,
  grade:'SS 304 Sheets & Plates'
  ,
  link:'/SS304Grade'
},
{
  id:8,
  grade:' SS 304L Sheets & Plates',
  link:'/SS304LGrade'
},
{
  id:9,
  grade:'SS 304H Sheets & Plates',
  link:'/SS304HGrade'
},
{
  id:10,
  grade:'SS 310S Sheets & Plates',
  link:'/SS310SGrade'
},
{
  id:11,
  grade:'SS 310H Sheets & Plates',
  link:'/SS310HGrade'
},
{
  id:12,
  grade:'SS 316  Sheets & Plates',
  link:'/SS316HGrade'
},
{
  id:13,
  grade:'SS 316Ti Sheets & Plates',
  link:'/SS316TiGrade'
},

{
  id:15,
  grade:'SS 321/321H Sheets & Plates',
  link:'/SS321Grade'
},
{
  id:16,
  grade:'SS 904L Sheets & Plates',
  link:'/SS904LGrade'
},

{
  id:18,
  grade:'SS 409 Sheets & Plates',
  link:'/SS409Grade'
},
// {
//   id:19,
//   grade:'SS 409L Sheets & Plates',
//   link:'/SS409LGrade'
// },
// {
//   id:20,
//   grade:'SS 409M Sheets & Plates',
//   link:'/SS409MGrade'
// },
// {
//   id:21,
//   grade:'SS 410 Sheets & Plates',
//   link:'/SS410Grade'
// },
{
  id:22,
  grade:'SS 410S Sheets & Plates',
  link:'/SS410SGrade'
},
{
  id:23,
  grade:'SS 420 Sheets & Plates',
  link:'/SS420Grade'
},

]


export const  SSCoilsGradeData=[

  {
    id:1,
    grade:'SS 201 Coils & Stirps',
    link:'/SS201CoilsGrade'
  },
  {
    id:2,
    grade:'SS 202 Coils & Stirps',
    link:'/SS202CoilsGrade'
  },

  {
    id:7,
    grade:'SS 304 Coils & Stirps'
    ,
    link:'/SS304CoilsGrade'
  },
  {
    id:8,
    grade:' SS 304L Coils & Stirps',
    link:'/SS304LCoilsGrade'
  },
  {
    id:9,
    grade:'SS 304H Coils & Stirps',
    link:'/SS304HCoilsGrade'
  },
  {
    id:10,
    grade:'SS 310S Coils & Stirps',
    link:'/SS310SCoilsGrade'
  },
  {
    id:11,
    grade:'SS 310H Coils & Stirps',
    link:'/SS310HCoilsGrade'
  },
  {
    id:12,
    grade:'SS 316  Coils & Stirps',
    link:'/SS316HCoilsGrade'
  },
  {
    id:13,
    grade:'SS 316Ti Coils & Stirps',
    link:'/SS316TiCoilsGrade'
  },{
    id:14,
    grade:'SS 316L  Coils & Stirps',
    link:'/SS316LCoilsGrade'
  },
  
  {
    id:16,
    grade:'SS 904L Coils & Stirps',
    link:'/SS904LCoilsGrade'
  },
  
 
  // {
  //   id:19,
  //   grade:'SS 409L Coils & Stirps',
  //   link:'/SS409LGrade'
  // },
  // {
  //   id:20,
  //   grade:'SS 409M Sheets & Plates',
  //   link:'/SS409MGrade'
  // },
  // {
  //   id:21,
  //   grade:'SS 410 Sheets & Plates',
  //   link:'/SS410Grade'
  // },
  {
    id:22,
    grade:'SS 410S Coils & Stirps',
    link:'/SS410SCoilsGrade'
  },
  {
    id:23,
    grade:'SS 420 Coils & Stirps',
    link:'/SS420CoilsGrade'
  },
  
  ]

  export const SS201SheetData=[


    {
      text1:'Stainless Steel 201 Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
      text2:'>Modi Metals.is a well known producer of SS 201 Sheets, Plates and Coils arranged in India. We have top tier precisely arranged warehousing workplaces that usage present day equipment for the production of Stainless Steel 201 Coils. We keep up a readied accessible to be acquired load of Stainless Steel 201 Sheets and Stainless Steel 201 Plates of fluctuating thickness that guarantees high caliber close by a solid introduction.',
      text3:'We are lofty in the business for our Stainless Steel 201 Hot and Cold Rolled Plates that are in consistence with the national and general standards. Solidified Steel 201 Checkered Plates are similarly offered in 2-3 mm, 3-4 mm, 4-5 mm and 5 mm thickness. All our Stainless Steel 201 Polished Plates are offered at an incredibly engaged expense to all of our clients and customers.',
      image:require("../../Constants/Images/SheetImg/SheetImg1.jpg"),
      Specifications:
        {
          Grade:'AISI201 (1.4372)',
          Standard :'ASTM A240/A480',
          Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
          Thickness:'0.5 mm to 30mm',
          Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
          Finish:'the surface and finish of 301 stainless steel plate 2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc',
          Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
        
          application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
        }
      ,
      
      
      chemical: 
  
        {
          Grade:'SS 201',
          c:'0.020 max',
          Mn:'2 max',
          Si:'1.00 max',
          P:'0.040 max',
          S:'0.030 max',
          Cr:'19.00 - 23.00',
          Mo:"4.00 - 5.00",
          Ni:'23.00 - 28.00',
          Cu:'1.00 - 2.00',
         
        }
      ,
      
    },
   
  ]

export const SS202Data=[


  {
    text1:'Stainless Steel 202 Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:'Modi Metals is one of the essential producer and provider of Stainless Steel 202 Sheets, Plates and Coils, masterminded in India. Our Stainless Steel 202 Sheets and Stainless Steel 202 Coils are reasonable for making particular mechanical things. Treated Steel 202 Plates are made by us utilizing high-grade quality set steel which is without rust and has smooth wrapping up.',
    text3:'We structure and make Stainless Steel 202 Coils in thickness running from 0.3mm-50mm, with widths of 0.3mm-50mm. Our ASTM A240 Stainless Steel 202 Hot Rolled Coils are open in various lengths going from 1000mm-5500mm. We have some capacity in offering things with changed estimations. We offer Stainless Steel 202 Cold Rolled Coils and Stainless Steel 202 Slatting Coils the two of which meets the ideal mechanical benchmarks.',
  image:require("../../Constants/Images/SheetImg/SSheet202.jpg"),
    Specifications:
      {
        Grade:'SS 202',
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.5 mm to 30mm',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
        Finish:'the surface and finish of 301 stainless steel plate 2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 

      {
        Grade:'SS 202',
        c:'0.15 max',
        Mn:'7.50-10',
        Si:'1.0 max',
        P:'0.060 max',
        S:'0.030 max',
        Cr:'17 – 19',

        Ni:'4-6',

        N:'0.25 max'

      }
    ,
    
  },
 
]

export const SS301Data1=[


  {
    text1:'Stainless Steel 301 Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:'We are exporter of 301 Stainless Steel Plate in India, We are no.1 seller of AISI 301 Plate. We are also Suppliers of 301 tempered steel Plate in India, SS 301 DIN 1.4310, We are stacking 300 Ton UNS S30100 Plate of esteemed creator of solidified steel 301 infection moved Plate .',
    text3:'In case you are looking for greatest supplier of 301 Stainless Steel Plate in India, Hot Rolled 301 SS Plate dealer, We can offer you outright best cost of ASTM/ASME A240 301 Stainless Steel Plate in most restricted movement time. We are Wholesaler of SS Plate of Baosteel, Nippon Steel, ThyssenKrupp, Arcelor Mittal, Nas, KDC Korea. We are offering extraordinary expense on surplus inventory of WERKSTOFF NO. 1.4310 301 Plate in India',
    image:require("../../Constants/Images/SheetImg/SheetImg2.jpg"),
    Specifications:
      {
        Grade:'SS 301',
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.5 mm to 30mm',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
        Finish:'the surface and finish of 301 stainless steel plate 2B, 2D, BA, NO.1, NO.4, NO.8, 8K, mirror, checkered, embossed, hair line, sand blast, Brush, etching, etc',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 

      {
        Grade:'SS 301',
        c:'0.15 max',
        Mn:'7.50-10',
        Si:'1.0 max',
        P:'0.060 max',
        S:'0.030 max',
        Cr:'17 – 19',
        Ni:'4-6',
        N:'0.25 max'

      }
    ,
    
  },
 
]

export const SS301Data=[


  {
   
    text1:'Stainless Steel 304 Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:'All around mentioned the fervor of the mechanical things is connecting as you beyond question understand each new thing improve the working of the forefront things. Much indistinguishable to the sheets and plates which look direct the material which is used in it makes the thing strong and best to use. Treated Steel 304 Sheets and Plates, it is said to be a manager among the most all around used tempered steel that offers sponsorship to the thing for long and it even keeps up the structure of the plates and sheets for long. If you look at the thing outline, by then you will find that its thickness contrasts from 0.3 to 120mm. These steels and plates are extensively used in the enormous affiliations.',
    text3:'We are exporter of 301 Stainless Steel Plate in India, We are no.1 seller of AISI 301 Plate. We are also Suppliers of 301 tempered steel Plate in India, SS 301 DIN 1.4310, We are stacking 300 Ton UNS S30100 Plate of esteemed creator of solidified steel 301 infection moved Plate .',
    image:require("../../Constants/Images/SheetImg/SheetImg3.jpg"),
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 

      {
        Grade:'SS 304',
        c:'0.08 max',
        Mn:'2 max',
        Si:'0.75 max',
        P:'0.045 max',
        S:'0.030 max',
        Cr:'18 – 20',
        Ni:'8 – 11',

      }
    ,
    
  },
 
]


export const SS304LData=[
  {
    
    text1:'Stainless Steel 304L Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:'',
    text3:'The Stainless Steel 304L Sheets and Plates are enduring and can fit into any length with no burden and it is open in various shapes and sizes. The Modi Metals is a standard, exporter and provider of SS sheets and plates and this thing is utilized in different relationship for various applications. It is dealt with by national in like way as expansive standards.',
    image:require("../../Constants/Images/SheetImg/SheetImg4.jpg"),
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 

      {
        Grade:'SS 304L',
        c:'0.035 max',
        Mn:'2.0 max',
        Si:'1.0 max',
        P:'0.045 max',
        S:'0.03 max',
        Cr:'18 – 20',
        Ni:'8 – 11',
      }
    ,



    
  }
]


export const SS304HData=[
  {
    image:require("../../Constants/Images/SheetImg/SheetImg5.jpg"),
    text1:'Stainless Steel 304H Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:'Stainless Steel 304H Sheets and Plates, it is a victor among the most extraordinary treated steel grades. In it, you will discover the utilization of the nickel at 8% and chromium 18%. By this, in this material, you will discover the usage of the carbon content that is 0.08%. You will regularly discover this examination of the steel in the cooking mechanical parties and dish. It is in addition known in the market in setting on its adaptable highlights. It other than has the best isolating square cutoff; with that, it in like way has the high straightforwardness of the creation property.',
    text3:"At present in the market there are extents of affiliations who use to make this evaluation of tempered steel at any rate the one which is known as the standard one is the Modi Metals. They utilize the best thought of mess material that develops the properties of the thing. Tempered Steel 304H Sheets and Plates even has the extraordinary yield and steadfast nature that make the thing solid and sorted out to hold up under any climatic condition. It doesn't get rust snappier paying little personality to whether it utilized in the wet air. The utilization of standard making process gives the thing long life.",
  
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
      
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 
  
      {
        Grade:'SS 304H',
        c:'0.10 max',
        Mn:'2.0 max',
        Si:'0.75 max',
        P:'0.045 max',
        S:'0.03 max',
        Cr:'18 – 20',
        Mo:'',
        Ni:'8 – 10.5',
        Cu:'',
  
      }
    ,
    
  }
]


// import img from "../../Constants/Images/SheetImg/SheetImg8.jpg"

export const SS310SData=[
  {
    
    text1:'Stainless Steel 310S Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:'The Stainless Steel 310s Sheets and Plates keeps running with historic features and are plan as indicated by client unequivocal necessities. The Stainless Steel sheets and plates of evaluation 310S are made by using the top class grungy material. It has features like high bore, exceptional, easy to fit, disavow in high temperature and weight condition. The Stainless Steel sheets plates are made by satisfy far reaching and adjoining standards of various endeavors measures. These Stainless Steel sheets and plates materials are given ISO accreditation and are shown to various testing to ensure its quality before transport and thing to the client.',
    text3:"The Stainless Steel 310s Sheets and Plates are dealt with by client's need and necessities and has high hunt down after. You can without a lot of a stretch get this thing from our confined and online shops at a moderate expense. This Stainless Steel plate and sheets can fit adequately and is open in phenomenally made size and shapes. These things are routinely used in various endeavors for various purposes.",
    image:require("../../Constants/Images/SheetImg/SheetImg8.jpg"),
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
     
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 
      {
        Grade:'SS 310S',
        c:'0.08 max',
        Mn:'2.0 max',
        Si:'1.00 max',
        P:'0.045 max',
        S:'0.030 max',
        Cr:'24 – 26',
        Mo:'0.75 max',
        Ni:'19 - 21',
        Fe:'53.095 min',
      }
  
    ,
    
  }
]

export const SS310HData=[

  {
    image:require("../../Constants/Images/SheetImg/SheetImg7.jpg"),
    text1:'Stainless Steel 310H Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:'Stainless Steel 310H Sheets & Plates Supplierss,Stainless Steel 310H Sheets & Plates Exporters,Stainless Steel 310H Sheets & Plates Suppliers,Stainless Steel 310H Sheets & Plates Importers,Stainless Steel 310H Sheets & Plates Stockists,UNS S31009 Stainless Steel 310H Sheets & Plates, ASTM A240 SS TP310H Sheets And Plates.',
    text3:"The best thing about these Stainless Steel 310 H Sheets and Plates is that it is coordinated by following the general and national extents of grungy material that structure the thing and makes it best to be used in any of the endeavors. If you need it in different thickness and style, by then it is dynamically quick to put in a deals for the social event connection first. They set up your thing as appeared by your referenced nuances so you can display it successfully where you need.",
  
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
      
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 
      {
        Grade:'SS 310H',
        c:'0.04 – 0.1',
        Mn:'2.0 max',
        Si:'1.00 max',
        P:'0.045 max',
        S:'0.030 max',
        Cr:'24 – 26',
        Mo:'0.75 max',
        Ni:'19 - 21',
        Fe:'53.095 min',
      }
      
    ,
    
  }
]

export const SS316Data=[

  {
    image:require("../../Constants/Images/SheetImg/SheetImg8.jpg"),
    text1:'Stainless Steel 316 Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:'The Stainless Steel 316 Sheets and Plates are made by ASTM A240/ASME A480. The width of this SS thing is exhibited to different surface medicines, for example, verified, painted, hot rolled and cold rolled and others. These SS sheets come in different estimations and accessible in remarkably made sizes and thickness. On the off chance that we talk about its Ss sheet thickness it lies in least 0.6 mm and most silly 4.00mm. This appraisal 316 of Ss sheet and plate is verified with very separating shading.',
    text3:"The Stainless Steel 316 Sheets and Plates are exhibited to different tests, for example, radiography test, ultrasonic test, and others to guarantee its quality and to clarify it is free from any twisting and perfection. Our affiliation passes on SS plates and sheets supply with a total arrangement of creation line test reports and are cut by your focal points.",
  
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
    
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 
      {
        Grade:'SS 316',
        c:'0.08 max',
        Mn:'2.0 max',
        Si:'1.00 max',
        P:'0.045 max',
        S:'0.030 max',
        Cr:'16 – 18',
        Mo:'2 – 3',
        Ni:'11 – 14',
        Fe:'67.845 min',
      }
      
    ,
    
  }
]


export const SS316LData=[
  {
    image:require("../../Constants/Images/SheetImg/SheetImg9.jpg"),
    text1:'Stainless Steel 316L Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:"They make the thing as per the referenced guidelines that ensure the standard of the thing. These evaluation materials can certainly be dealt with no uneasiness. This thing can without a lot of a stretch be upheld in the crazy cools since it has the best deterrent breaking point that makes it strong to be used in a mechanical applications. It can work in low and high both kind of temperature all such intricacy in the air condition don't influence the thing quality in light of how the compound which is used in it making is of respect types and makes its readied to be used it wherever in endeavors.",
    text3:"The Stainless Steel 316L Sheets and Plates come in different estimations and shapes by virtue of which customer get the one which they need for their endeavors. They are even exceptional in nature, strong and mindful treated steel. You will in like manner find its usage in the marine relationship in setting on its high bore and ruinous properties.",
  
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
  
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 
      {
        Grade:'SS 316L',
        c:'0.08 max',
        Mn:'2.0 max',
        Si:'1.00 max',
        P:'0.045 max',
        S:'0.030 max',
        Cr:'16 – 18',
        Mo:'2 – 3',
        Ni:'11 – 14',
      
        Fe:'67.845 min',
      }
      
    ,
    
  }
]

export const SS316HData=[

  {
    image:require("../../Constants/Images/SheetImg/SheetImg10.jpg"),
    text1:'Stainless Steel 316H Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:"It comes in ASTM A240 and ASME SA240 and has estimations, for instance, DIN, BS, JIS, GB, EN, AISI, etc. The Stainless Steel 316H Sheets and Plates are open in various structures, for instance, plain sheet, Designer sheet, seem sheet, checkered plate, and others. It is open in tantamount examinations, for instance, 316H UNS (S31609) and DIN (1.4401). It is open in following length 2000mm, 2440mm, 3000mm, 5800mm, 6000 mm, etc.",
    text3:"Stainless Steel 316H Sheets and Plates is available in thickness go 0.3mm to 6mm and hardness is offered by ASME An and NACE MR 175. It is connected by surface coatings, for instance, confirmed, painted, hot moved plate and cold moved sheets, SATIN (met with plastic checked) and others. The extent of this plate and sheet is ¼ to 4. The Stainless Steel 316H Sheets and Plates is tried well to check the thing quality and are pulverized well in order to keep up a key segment from any kind of outside mischief.",
  
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 
      {
        Grade:'SS 316H',
        c:'0.10 max',
        Mn:'2.0 max',
        Si:'0.75 max',
        P:'0.045 max',
        S:'0.030 max',
        Cr:'16 – 18',
        Mo:'2 – 3',
        Ni:'10 – 14',
        Fe:'68.89 min',
      }
      
    ,
    
  }
]

export const SS316TiData=[

  {
    text1:'Stainless Steel 316Ti Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:"Modi Metals is known to be the most trustful distributor that strategies the best idea of Stainless Steel 316Ti Sheets and Plates. They are quickly drawn and framed. Its properties are by somehow essentially indistinguishable to the 316-grade blend yet the usage of titanium manufactures makes it sensible to be used in the raised temperatures. The glimmer treatment increase the change of the thing in this framework the titanium reacts with the carbon that shapes the titanium carbides.",
    text3:"Its width comes in 1000, 1219, 1500, 1800, 2000, 2500, 3000, 3500mm, etc. Other than this, the length comes in 2000, 2440, 3000, 5800, 6000, etc. Here the thickness in like manner changes from 0.3 to 10.0 mm. its structure is moreover wide you can pick one of your choices. Its substance creation is too strong that changes into the clarifications for its incredible game-plan and structure. Tempered Steel 316Ti Sheets and Plates are in the end changing into the essential choice of the entire industrialist they need that they applications stay in working condition for long.",
  
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 
      {
        Grade:'SS 316Ti',
        c:'0.08 max',
        Mn:'2.0 max',
        Si:'0.75 max',
        P:'0.045 max',
        S:'0.030 max',
        Cr:'16 – 18',
        Mo:'2 – 3',
        Ni:'10 – 14',
        Fe:'68.395 min',
        
      }
      
    ,
    
  }
]


export const SS321Data=[
  {
    text1:'Stainless Steel 321/321H Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:"Stainless Steel 321/321H Sheets and Plates, these are known as consistent set steel grade that offers huge positive conditions to the customers. Verifiably the central immaculate position is its noticeable resistance property in the intergranular utilize that following the prelude to the temperature which is in the chromium carbide precipitation runs that from 800 to 1500 degree F. It changes into the settled before the chromium in light of the use of titanium that quality the thing staggering.",
    text3:"Stainless Steel 321/321H Sheets and Plates even don't get set up when it goes under the sparkle treatment this is done just by illness working. It can no two ways about it get welded and managed when it goes under the perfect creation process. Consequently, after a short time you know why you should buy this thing for use circumscribing this in case you need the best quality plate, by then visit once on the Modi Metals",
  
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 
      {
        Grade:'SS 321',
        c:'0.08 max',
        Mn:'2.0 max',
        Si:'1.0 max',
        P:'0.045 max',
        S:'0.030 max',
        Cr:'17 – 19',
        Mo:'2 – 3',
        Ni:'9 – 12',
        Ti:'5(C+N) – 0.70 max',
        Fe:'68.395 min',
      }
      
    ,
    
  }
]


export const SS904LData=[

  {
    text1:'Stainless Steel 904L Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:"TP904L Stainless Steel Hot Rolled (HR) Sheets Suppliers, ASTM B625 Stainless Steel 904L Bright Annealed Finish (BA) Sheets Wholesaler, SS 904L Plates, TP904L Stainless Steel Slit Coils, Stainless Steel 904L Sheets, Stainless Steel TP904L Chequer (Floor) Sheets Distributor, 904L Stainless Steel Coils Stockholder, SS TP904L Cold Rolled (CR) Plates Exporter, ASME SB625 SS TP904L Shim Sheets In Mumbai, Indi, TP904L Stainless Steel B625M Flats, Strips, Foils, Circles, Rings, Blanks Dealer, Stainless Steel 904L Polished Finishes Sheets & Plates, DIN 1.4539 SS Embossed Sheets Stock, SS TP904L 2B Finish Plates Stockist, TP904L Stainless Steel Mill Finished Sheets Distributor, UNS N08904 Steel 2D Finish Sheets Distribution, Stainless Steel TP904L 8 Finish Sheets Traders, SS 904L 4 Finish Sheets Supplier.",
    text3:"In this assessment steel, you will find the usage of the chromium and nickel that makes it extraordinary to be used in a critical number of the pushed things. Treated Steel 904L Sheets and Plates even stay protected from the chloride strike and warm seawater in light of the improvement appearances that shield it from insidiousness. It comes in enormous estimations customer can pick it as per their need. It even comes everything standard sizes that most customers demand.",
  
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 
      {
        Grade:'SS 904L',
        c:'0.020 max',
        Mn:'2.0 max',
        Si:'1.0 max',
        P:'0.040 max',
        S:'0.030 max',
        Cr:'19 – 23',
        Mo:'4 – 5',
        Ni:'23 – 28',
        Cu:'1-2',
      }
      
    ,
    
  }
]


export const SS409Data=[
  {
    text1:'Stainless Steel 409 Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:"Stainless Steel 409 SHEETS/PLATES are the plates which are conveyed using the best thought of unpleasant material. The use of such foul material makes the exact opposite thing best in all terms. Fundamentally, in this evaluation of steel, you will the utilization of the titanium, chromium that sensible out the property well in it. Modi Metals one of the remarkable makers shows to all of you the bits of learning concerning their thing to the clients since they need to get their client trust for long. They make this evaluation plate and sheets which are in cooperated with the best thought of the material.",
    text3:"Cemented Steel 409 Sheets/Plates standard focal points come in various range as shown by the client's decisions. Along these lines they can without a great deal of a stretch satisfy their essential applications needs. So in the event that you are filtering for best associations, by then interface with us",
  
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 
      {
        Grade:'SS 409',
        c:'0.020 max',
        Mn:'1 max',
        Si:'1.0 max',
        P:'0.045 max',
        S:'0.045 max',
        Cr:'10.5 – 11.75',
        Mo:'4 – 5',
        Ni:'0.5 max',
      
        Ti:'6x C – 0.75'
      }
      
    ,
    
  }
]

export const SS410Data=[
  {
    text1:'Stainless Steel 410 Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:"We offer SS sheets thing at a reasonable market cost and we pass on this thing with various test demands, for instance, ISO confirms and others. The SS sheets keep running with ASTM A240/ASME SA240. This immaculate sheet 410 assessment are acquainted with various surface finishi8ng, for instance, FINISH-2B/HR, hot moved, cold rolled and others. In case we look at about its size, 1000x2000, 1220x2440, etc, its thickness ranges from 0.3mm to 120mm. These 410 SS sheets are confirmed with PVC covering, Laser covering, Film: 100 micrometer, Color: dull/white. The width of the SS sheet is 1000mm, 1250mm, 1500mm, and 2000mm and benefitted on customer's arrangements.",
    text3:"The Stainless Steel 410 Sheets are stacked down with fixed material in order to give protection from outside mischief. We will give you Ss sheet material with no deformation and imperfection. To ensure the likelihood of the last outcome, we are applying indisputable testing systems on solidified steel and starting there the thing is passed on to you inside a short time span.",
  
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 
      {
        Grade:'SS 410',
        c:'0.15 max',
        Mn:'1 max',
        Si:'1.0 max',
        P:'0.040 max',
        S:'0.030 max',
        Cr:'11.5 – 13.75',
        Mo:'4 – 5',
        Ni:'0.5 max',
        Ti:'0.10 - 0.60',
        Nb:'0.3+3-1',
       
      }
      
    ,
    
  }
]

export const SS420Data=[
  {
    text1:'Stainless Steel 420 Sheets & Plates  Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
    text2:"Stainless Steel 420 Sheets/Plates, it's a changed variety of the 410 evaluation of treated steel in it the carbon content is high that improvement the hardness of the thing outstandingly and make it orchestrated to be utilized in a critical number of the propelled thing. This all-encompassing extent of the carbon in like way improves the idea of the plates and sheets and offers its better square wearing quality. It's an appraisal which offers the best usage limitation property that even works in the sparkle treated conditions.",
    text3:"Stainless Steel 420 Sheets/Plates thickness shifts from 0.4 to 6.0mm, anyway analyzing its fulfillments by then FINISH-2B/HR is a hero among its best-completed works. Before long discussing its width by then is begin from 1000 and end up to the referenced sizes. The client can get the thing as demonstrated by their need. They can put in the requesting Modi Metals and get their thing on logbook. They even take affirmation of best working associations and best grade material. In the gathering strategy, they even use to look for after the standard which is set by the business that makes it best from all sides.",
  
    Specifications:
      {
        Standard :'ASTM / ASME A240 / SA240',
        Size:'1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
        Thickness:'0.01 mm to 250 mmThk',
        Form :'Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)',
        Finish:'Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)',
        Hardness:'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.',
      
        application:'Medical equipment, Food industry, Construction material, Kitchen utensils, BBQ grill, Building construction, Electric equipment,'
      }
    ,
    
    
    chemical: 
      {
        Grade:'SS 420',
        c:'0.15 max',
        Mn:'1 max',
        Si:'1.0 max',
        P:'0.040 max',
        S:'0.030 max',
        Cr:'12 – 14',
      }
      
    ,
    
  }
]